<script>
import Resultado from "./Resultado.vue";

export default {
  components: { Resultado },
  props: {
    cantidad: { type: Number, required: false, default: 5 }
  }
};
</script>

<template>
  <div class="resultados-placeholder">
    <resultado v-for="n in cantidad" :key="n"></resultado>
  </div>
</template>

<style lang="scss" scoped>
.resultados {
}
</style>